import store from '../store'
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
import CONFIG from '../config'

const url = CONFIG.SLACK_WEBHOOK

const sendToSlack = (response, request = null, allCookies = {}) => {
    // const keys = ['accessToken', 'idToken', 'lastAuthUser', 'refreshToken']
    // let cookies = {}
    // keys.forEach(name => {
    //     const key = Object.keys(allCookies).find(item => item.endsWith(name))
    //     if (key) cookies[name] = allCookies[key]
    // })
    const text =
        '*response* ' + '```' + JSON.stringify(response, null, 2) + '``` ' +
        '*request* ' + '```' + JSON.stringify(request, null, 2) + '``` ' +
        '*cookies* ' + '```' + JSON.stringify(allCookies, null, 2) + '``` ' +
        '*url* ' + '`' + location.href + '` \n' +
        '*user agent* ' + '`' + navigator.userAgent + '` \n' +
        '*' + moment().format('LLLL') + '*'
    return axios.post(url, JSON.stringify({ text }))
}

Vue.mixin({
    methods: {
        $sendToSlack (err) {
            sendToSlack(err)
        },
        $showError (err = null) {
            if (err) store.dispatch('errors/add', err)
            store.dispatch('errors/show')
        },
        $hideError () {
            store.dispatch('errors/hide')
        },
        $addError (err) {
            store.dispatch('errors/add', err)
        },

        $stopSpinner () {
            store.dispatch('spinner/stop')
        }
    }
})

export { sendToSlack }
